import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { constHeaders } from "../constants/AveragedHeaders";
import ConfigurableRow from "./averaged-rows/configurable-row";
import * as configs from "./averaged-rows/calibration-config";

export default function AveragedCalibrationsTable({
  data,
  clickedOption,
  removeGroupHandler,
  updateData,
}) {
  const configMap = {
    0: configs.baseConfig,
    1: configs.modelConfig,
    2: configs.brandConfig,
    3: configs.manufacturerConfig,
  };

  const activeConfig = configMap[clickedOption];

  if (!activeConfig) {
    return null;
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          {constHeaders[clickedOption].map((header, index) => (
            <TableCell key={index}>{header}</TableCell>
          ))}
        </TableHead>
        <TableBody>
          {data.map((dataRow) => (
            <ConfigurableRow
              key={dataRow.id}
              data={dataRow}
              updateData={updateData}
              config={activeConfig}
              removeGroupHandler={removeGroupHandler}
              mainCalibrations={
                Array.isArray(dataRow.calibrations)
                  ? dataRow.calibrations.map(
                      (calibration) => calibration.appVolume
                    )
                  : []
              }
              selectedOption={clickedOption}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
